import React, {useMemo, useState} from "react";
import {Card, CardBody, CardHeader,} from "../../../../../_metronic/_partials/controls";
import PhotosTable from "./PhotosTable";
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app
import Lightbox from 'react-image-lightbox';
import {useProductsUIContext} from "../../ProductsUIContext";
import {domain} from "../../../../../_metronic/_helpers/GlobalConsts";

export default function ProductPhotos() {

    const [index, setIndex] = useState(0);
    const [photoOpenPreview, setPhotoOpenPreview] = useState(false);
    const productContext = useProductsUIContext();
    const productUIProps = useMemo(() => {
        return {
            id: productContext.id,
            setId: productContext.setId,
            product: productContext.product,
            photos: productContext.photos,
            setPhotos: productContext.setPhotos,
            error: productContext.error,
            setError: productContext.setError,
            setOpenError: productContext.setOpenError,
        }
    }, [productContext]);

    const handlePreview = (id) => {
        setPhotoOpenPreview(true);
        for (let i = 0; i < productUIProps.product.images.length; i++) {
            if (productUIProps.product.images[i].id === id) {
                setIndex(i);
            }
        }
    };

    return (
        <>
            <Card>
                <CardHeader title="تصاویر محصول">
                </CardHeader>
                <CardBody>

                    <PhotosTable handlePreview={handlePreview}/>


                    {photoOpenPreview && (
                        <Lightbox
                            mainSrc={domain + productUIProps.product.images[index].url}
                            nextSrc={domain + productUIProps.product.images[(index + 1) % productUIProps.product.images.length]}
                            prevSrc={domain + productUIProps.product.images[(index + productUIProps.product.images.length - 1) % productUIProps.product.images.length]}
                            onCloseRequest={() => setPhotoOpenPreview(false)}
                            onMovePrevRequest={() =>
                                setIndex((index + productUIProps.product.images.length - 1) % productUIProps.product.images.length)
                            }
                            onMoveNextRequest={() =>
                                setIndex((index + 1) % productUIProps.product.images.length)
                            }
                            clickOutsideToClose={true}
                        />
                    )}

                </CardBody>
            </Card>
        </>
    )
}